import { lightbox } from '../Helper/iFrame';

lightbox('vimeo');
